<template>
  <p>You do not have access to this application.</p>
</template>

<script>
export default {
  components: {
  }
}
</script>
